import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const TransferSimple = () => import('@/views/TransferSimple.vue')
const TransferMass = () => import('@/views/TransferMass.vue')
const FeatureUnavailable = () => import('@/views/FeatureUnavailable.vue')
const Support = () => import('@/views/Support.vue')

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/transfer'
    },
    {
      path: '/transfer',
      name: 'TransferSimple',
      component: TransferSimple
    },
    {
      path: '/transfer-mass',
      name: 'TransferMass',
      component: TransferMass
    },
    {
      path: '/historique',
      name: 'Historique',
      component: FeatureUnavailable
    },
    {
      path: '/cryptomonnaie',
      name: 'Cryptomonnaie',
      component: FeatureUnavailable
    },
    {
      path: '/support',
      name: 'Support',
      component: Support
    },
    {
      path: '/feature-unavailable',
      name: 'FeatureUnavailable',
      component: FeatureUnavailable
    }
  ]
})